import script from "./input-registration-number.vue?vue&type=script&setup=true&lang=js"
export * from "./input-registration-number.vue?vue&type=script&setup=true&lang=js"

import "./input-registration-number.vue?vue&type=style&index=0&id=7ca95db3&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca95db3"]])

export default __exports__